import React, { useState, useEffect } from "react";

const AVAILABLE_SPACE_OPTIONS = [
  "< 500 sq ft",
  "500 – 1000 sq ft",
  "1000 – 2000 sq ft",
  "2000+ sq ft",
];

const ORG_TYPE_OPTIONS = [
  "School (CBSE)",
  "School (State Board)",
  "School (ICSE)",
  "College / University",
  "Other Institution",
];

const LAB_TAGLINES = {
  "STEM Lab":         { tag: "iBots STEM Lab",         title: "Build Tomorrow's\nInnovators Today.",        desc: "Hands-on STEM kits, electronics & robotics — igniting curiosity from the classroom." },
  "Robotics Lab":     { tag: "iBots Robotics Lab",      title: "Think. Build.\nRobot.",                      desc: "From Arduino to autonomous bots — real engineering skills for future tech leaders." },
  "Innovation Lab":   { tag: "iBots Innovation Lab",    title: "Empowering Minds.\nBuilding Futures.",        desc: "Hands-on training in electronics, embedded systems, drones & IoT — bridging academia with industry." },
  "ATL Lab":          { tag: "iBots ATL Lab",           title: "Tinker. Invent.\nTransform.",                 desc: "Design thinking, 3D printing & coding — a complete Atal Tinkering Lab experience." },
  "Drone Lab":        { tag: "iBots Drone Lab",         title: "Fly Higher.\nBuild Smarter.",                 desc: "Hands-on UAV assembly, flight simulation & aerial data processing — bridging academia with industry." },
  "IoT,IIOT & AIOT Lab": { tag: "iBots IoT Lab",        title: "Connect Devices.\nChange the World.",        desc: "Edge AI, cloud IoT & smart automation — building the engineers of tomorrow." },
  "AICTE Idea Lab":   { tag: "iBots AICTE Idea Lab",    title: "Ideate. Fabricate.\nInnovate.",               desc: "A fully equipped tinkering & fabrication lab aligned with AICTE Idea Lab guidelines." },
  "Customised Lab":   { tag: "iBots Custom Lab",        title: "Your Vision.\nOur Expertise.",               desc: "Tailored lab setup to match your institution's space, curriculum & goals." },
};

const DEFAULT_TAGLINE = {
  tag: "iBots Innovation Lab",
  title: "Empowering Minds.\nBuilding Futures.",
  desc: "Hands-on training in electronics, embedded systems, drones & IoT — bridging academia with industry.",
};

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=600&q=80";

const css = `
.eq-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 50, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: eqOverlayIn 0.2s ease;
}
@keyframes eqOverlayIn { from { opacity:0 } to { opacity:1 } }

.eq-modal {
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 820px;
  max-height: 92vh;
  display: flex;
  overflow: hidden;
  box-shadow: 0 28px 90px rgba(10,20,60,0.25);
  animation: eqModalIn 0.3s cubic-bezier(0.34,1.2,0.64,1);
  position: relative;
}
@keyframes eqModalIn {
  from { opacity:0; transform:translateY(28px) scale(0.96) }
  to   { opacity:1; transform:translateY(0)    scale(1) }
}

.eq-left {
  width: 340px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.eq-left-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.eq-left-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(5,15,40,0.82) 40%, rgba(5,15,40,0.25) 100%);
}
.eq-left-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 28px 24px;
}
.eq-left-tag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 20px;
  padding: 5px 12px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 14px;
  backdrop-filter: blur(6px);
}
.eq-left-dot {
  width: 7px;
  height: 7px;
  background: #22c55e;
  border-radius: 50%;
  flex-shrink: 0;
}
.eq-left-title {
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  line-height: 1.2;
  margin: 0 0 10px;
  font-family: 'Nunito','Segoe UI',sans-serif;
  white-space: pre-line;
}
.eq-left-desc {
  font-size: 12px;
  color: rgba(255,255,255,0.75);
  line-height: 1.6;
  margin: 0;
  font-family: 'Nunito','Segoe UI',sans-serif;
}

.eq-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.eq-right-header {
  padding: 28px 28px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid #f1f5f9;
}
.eq-right-header h2 {
  font-size: 20px;
  font-weight: 900;
  color: #0d2e6e;
  margin: 0 0 6px;
  line-height: 1.25;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
.eq-right-header p {
  font-size: 12.5px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
.eq-form-scroll {
  overflow-y: auto;
  flex: 1;
  padding: 18px 28px 24px;
}
.eq-form { display:flex; flex-direction:column; gap:13px; }
.eq-row { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
.eq-field { display:flex; flex-direction:column; gap:5px; }
.eq-field label {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
.eq-req { color:#e8394d; margin-left:2px; }
.eq-field input,
.eq-field textarea {
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  padding: 9px 13px;
  font-size: 12.5px;
  color: #1e293b;
  font-family: 'Nunito','Segoe UI',sans-serif;
  background: #f8fafc;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
  width: 100%;
  box-sizing: border-box;
}
.eq-field input::placeholder,
.eq-field textarea::placeholder { color:#b0bec5; }
.eq-field input:focus,
.eq-field textarea:focus {
  border-color: #1e3a8a;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(30,58,138,0.08);
}
.eq-field textarea { resize:vertical; min-height:72px; }
.eq-sel-wrap { position:relative; }
.eq-sel-wrap select {
  width: 100%;
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  padding: 9px 34px 9px 13px;
  font-size: 12.5px;
  color: #1e293b;
  font-family: 'Nunito','Segoe UI',sans-serif;
  background: #f8fafc;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s;
  box-sizing: border-box;
}
.eq-sel-wrap select:focus {
  border-color: #1e3a8a;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(30,58,138,0.08);
}
.eq-sel-arrow {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #94a3b8;
  pointer-events: none;
}
.eq-submit-btn {
  width: 100%;
  height: 48px;
  background: #0d2e6e;
  color: #fff;
  border: none;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 900;
  font-family: 'Nunito','Segoe UI',sans-serif;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  margin-top: 2px;
}
.eq-submit-btn:hover { background:#1e3a8a; transform:translateY(-1px); }
.eq-submit-btn:active { transform:translateY(0); }

.eq-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.18s, color 0.18s;
}
.eq-close-btn:hover { background:#fee2e2; color:#dc2626; border-color:#fca5a5; }

.eq-success {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  text-align: center;
  gap: 12px;
}
.eq-success-icon {
  width: 60px; height: 60px;
  border-radius: 50%;
  background: #dcfce7;
  color: #16a34a;
  font-size: 26px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  animation: eqPop 0.4s cubic-bezier(0.34,1.5,0.64,1);
}
@keyframes eqPop { from{transform:scale(0);opacity:0} to{transform:scale(1);opacity:1} }
.eq-success h2 {
  font-size: 21px; font-weight:900; color:#0d2e6e; margin:0;
  font-family:'Nunito','Segoe UI',sans-serif;
}
.eq-success p {
  font-size:13px; color:#64748b; margin:0; line-height:1.6; max-width:300px;
  font-family:'Nunito','Segoe UI',sans-serif;
}
.eq-success .eq-submit-btn { max-width:180px; margin-top:8px; }

@media (max-width:700px) {
  .eq-left { display:none; }
  .eq-modal { max-width:480px; }
  .eq-row { grid-template-columns:1fr; }
}
`;

export default function EnquiryForm({ labName, labImage, packageLabel, packagePrice, onClose }) {
  const tagline = LAB_TAGLINES[labName] || DEFAULT_TAGLINE;
  const image   = labImage || DEFAULT_IMAGE;

  const [form, setForm] = useState({
    contactPerson: "", designation: "", orgName: "",
    orgType: "", phone: "", email: "",
    city: "", availableSpace: "", message: "",
    source: "", customSource: "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!document.getElementById("eq-injected-css")) {
      const tag = document.createElement("style");
      tag.id = "eq-injected-css";
      tag.textContent = css;
      document.head.appendChild(tag);
    }
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

 const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'lab-setup-enquiry',
          labName: labName,
          contactPerson: form.contactPerson,
          designation: form.designation,
          institution: form.orgName,
          orgType: form.orgType,
          phone: form.phone,
          email: form.email,
          city: form.city,
          availableSpace: form.availableSpace,
          message: form.message,
          source: form.source === 'Other' ? form.customSource : form.source,
        }),
      });
    } catch (err) {
      console.log('Your backend error:', err);
    }

    try {
  await fetch('http://localhost:5000/api/lab', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      contactPerson: form.contactPerson,
      designation:   form.designation,
      organisation:  form.orgName,
      institution:   form.orgName,
      labName:       form.orgName,
      orgType:       form.orgType,
      labType:       labName,
      packageLabel:  packageLabel || '',
packagePrice:  packagePrice || '',
      studentType:   form.orgType.toLowerCase().includes('school') ? 'School' : 'College',
      phone:         form.phone,
      email:         form.email,
      city:          form.city,
      availableSpace: form.availableSpace,
      requirement:   form.message,
      source:        form.source === 'Other' ? form.customSource : form.source,
    }),
  });
} catch (err) {
  console.log('Dashboard backend error:', err);
}

    setSubmitted(true);
  };

  return (
    <div className="eq-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="eq-modal">
        <button className="eq-close-btn" onClick={onClose}>✕</button>

        {/* LEFT — image panel */}
        <div className="eq-left">
          <img src={image} alt={labName} className="eq-left-img" />
          <div className="eq-left-overlay" />
          <div className="eq-left-content">
            <div className="eq-left-tag">
              <span className="eq-left-dot" />
              {tagline.tag}
            </div>
            <h2 className="eq-left-title">{tagline.title}</h2>
            <p className="eq-left-desc">{tagline.desc}</p>
          </div>
        </div>

        {/* RIGHT — form */}
        <div className="eq-right">
          <div className="eq-right-header">
            <h2>
              Set Up {["ATL Lab", "Innovation Lab"].includes(labName) ? "an" : "a"} {labName}<br />at Your Institution
            </h2>
            <p>Submit your details and our team will contact you to help set up the right innovation lab for your institution.</p>
          </div>

          <div className="eq-form-scroll">
            {submitted ? (
              <div className="eq-success">
                <div className="eq-success-icon">✓</div>
                <h2>Enquiry Submitted!</h2>
                <p>Our team will reach out to you shortly about the <strong>{labName}</strong> setup.</p>
                <button className="eq-submit-btn" onClick={onClose}>Close</button>
              </div>
            ) : (
              <form className="eq-form" onSubmit={handleSubmit}>
                <div className="eq-row">
                  <div className="eq-field">
                    <label>Contact Person <span className="eq-req">*</span></label>
                    <input name="contactPerson" value={form.contactPerson} onChange={handleChange} placeholder="Full Name" required />
                  </div>
                  <div className="eq-field">
                    <label>Designation <span className="eq-req">*</span></label>
                    <input name="designation" value={form.designation} onChange={handleChange} placeholder="Principal / HOD / Director" required />
                  </div>
                </div>

                <div className="eq-field">
                  <label>Organisation Name <span className="eq-req">*</span></label>
                  <input name="orgName" value={form.orgName} onChange={handleChange} placeholder="School / College / Institution Name" required />
                </div>

                <div className="eq-field">
                  <label>Organisation Type <span className="eq-req">*</span></label>
                  <div className="eq-sel-wrap">
                    <select name="orgType" value={form.orgType} onChange={handleChange} required>
                      <option value="">— Select Type —</option>
                      {ORG_TYPE_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
                    </select>
                    <span className="eq-sel-arrow">▾</span>
                  </div>
                </div>

                <div className="eq-row">
                  <div className="eq-field">
                    <label>Phone <span className="eq-req">*</span></label>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" type="tel" required />
                  </div>
                  <div className="eq-field">
                    <label>Email <span className="eq-req">*</span></label>
                    <input name="email" value={form.email} onChange={handleChange} placeholder="official@email.com" type="email" required />
                  </div>
                </div>

                <div className="eq-row">
                  <div className="eq-field">
                    <label>City <span className="eq-req">*</span></label>
                    <input name="city" value={form.city} onChange={handleChange} placeholder="City" required />
                  </div>
                  <div className="eq-field">
                    <label>Available Space</label>
                    <div className="eq-sel-wrap">
                      <select name="availableSpace" value={form.availableSpace} onChange={handleChange}>
                        <option value="">— Select —</option>
                        {AVAILABLE_SPACE_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
                      </select>
                      <span className="eq-sel-arrow">▾</span>
                    </div>
                  </div>
                </div>

                <div className="eq-field">
                  <label>Message / Requirements</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Any specific requirements or questions..." rows={3} />
                </div>
                
                <div className="eq-field">
  <label>How did you hear about ibots? <span className="eq-req">*</span></label>
  <div className="eq-sel-wrap">
    <select name="source" value={form.source} onChange={handleChange}>
      <option value="">— Select —</option>
      {['Friend / Family Referral','School / College Recommendation','Google Search','Social Media (Instagram / Facebook)','YouTube','LinkedIn','WhatsApp','Newspaper / Magazine','Event / Hackathon','ibots Website','Other'].map((s) => (
        <option key={s} value={s}>{s}</option>
      ))}
    </select>
    <span className="eq-sel-arrow">▾</span>
  </div>
  {form.source === 'Other' && (
    <input type="text" name="customSource" value={form.customSource}
      onChange={handleChange} placeholder="Please tell us how you found us..."
      style={{ marginTop: '8px' }} />
  )}
</div>
                <button type="submit" className="eq-submit-btn">Submit Enquiry →</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}